"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/textField/index.ts
var textField_exports = {};
__export(textField_exports, {
  default: () => TextField_default
});
module.exports = __toCommonJS(textField_exports);
var import_index2 = require("./index.css");

// src/textField/TextField.tsx
var import_classnames3 = __toESM(require("classnames"));

// src/formFieldWrapper/index.ts
var import_index = require("./index.css");

// src/formFieldWrapper/FormFieldWrapper.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/formFieldWrapper/formFieldWrapper.module.scss
var formFieldWrapper_module_default = {
  "heading-xxl": "formFieldWrapper-module__heading-xxl___4CLqw",
  "heading-xl": "formFieldWrapper-module__heading-xl___eyqwq",
  "heading-lg": "formFieldWrapper-module__heading-lg___MLrX9",
  "heading-md": "formFieldWrapper-module__heading-md___f8a7H",
  "heading-sm": "formFieldWrapper-module__heading-sm___6kNRL",
  "heading-xs": "formFieldWrapper-module__heading-xs___GWC7M",
  "body-one": "formFieldWrapper-module__body-one___I4bPJ",
  "body-two": "formFieldWrapper-module__body-two___Zrpf5",
  "body-three": "formFieldWrapper-module__body-three___p0-8i",
  "body-four": "formFieldWrapper-module__body-four___feQQF",
  "overline-one": "formFieldWrapper-module__overline-one___Hrmh4",
  "overline-two": "formFieldWrapper-module__overline-two___P-L0I",
  "overline-three": "formFieldWrapper-module__overline-three___zbC04",
  "strong": "formFieldWrapper-module__strong___8BxXJ",
  "extra-strong": "formFieldWrapper-module__extra-strong___18BOS",
  "em": "formFieldWrapper-module__em___ZYLTg",
  "figcaption": "formFieldWrapper-module__figcaption___IB24m",
  "formFieldWrapper": "formFieldWrapper-module__formFieldWrapper___wa6RZ",
  "formFieldWrapperHelper": "formFieldWrapper-module__formFieldWrapperHelper___Di0P2",
  "formFieldWrapper-color-black": "formFieldWrapper-module__formFieldWrapper-color-black___9yNzp",
  "formFieldWrapperLabel": "formFieldWrapper-module__formFieldWrapperLabel___4tTzn",
  "formFieldWrapper-color-gray": "formFieldWrapper-module__formFieldWrapper-color-gray___pzU0N",
  "formFieldWrapperError": "formFieldWrapper-module__formFieldWrapperError___BI6Tj",
  "formFieldWrapper-color-white": "formFieldWrapper-module__formFieldWrapper-color-white___lY8Jq",
  "formFieldWrapper-size-l": "formFieldWrapper-module__formFieldWrapper-size-l___qnrHw",
  "formFieldWrapper-size-m": "formFieldWrapper-module__formFieldWrapper-size-m___2Q3pW",
  "formFieldWrapper-size-s": "formFieldWrapper-module__formFieldWrapper-size-s___uQOGl"
};

// src/formFieldWrapper/FormFieldWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var FormFieldWrapper = ({
  children,
  className,
  label,
  helperMessage,
  helperIcon,
  errorMessage,
  color = "black",
  size = "m",
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
  "label",
  {
    className: (0, import_classnames2.default)(
      formFieldWrapper_module_default.formFieldWrapper,
      formFieldWrapper_module_default[`formFieldWrapper-color-${color}`],
      formFieldWrapper_module_default[`formFieldWrapper-size-${size}`],
      className
    ),
    ...HTMLAttributes,
    children: [
      label && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: formFieldWrapper_module_default.formFieldWrapperLabel, children: label }),
      children,
      !errorMessage && helperMessage && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: formFieldWrapper_module_default.formFieldWrapperHelper, children: [
        helperIcon && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: helperMessage })
      ] }),
      errorMessage && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
        "div",
        {
          className: (0, import_classnames2.default)(
            formFieldWrapper_module_default.formFieldWrapperHelper,
            formFieldWrapper_module_default.formFieldWrapperError
          ),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: errorMessage })
          ]
        }
      )
    ]
  }
);
var FormFieldWrapper_default = FormFieldWrapper;

// src/textField/textfield.module.scss
var textfield_module_default = {
  "heading-xxl": "textfield-module__heading-xxl___MW2BP",
  "heading-xl": "textfield-module__heading-xl___xNHov",
  "heading-lg": "textfield-module__heading-lg___E6Y91",
  "heading-md": "textfield-module__heading-md___aNTwk",
  "heading-sm": "textfield-module__heading-sm___dMbk3",
  "heading-xs": "textfield-module__heading-xs___diX4s",
  "body-one": "textfield-module__body-one___y3k2Y",
  "body-two": "textfield-module__body-two___HHHEG",
  "body-three": "textfield-module__body-three___MZKcY",
  "body-four": "textfield-module__body-four___xGQvd",
  "overline-one": "textfield-module__overline-one___7SqVP",
  "overline-two": "textfield-module__overline-two___hpCd1",
  "overline-three": "textfield-module__overline-three___NwoR8",
  "strong": "textfield-module__strong___LVK4n",
  "extra-strong": "textfield-module__extra-strong___F9tTs",
  "em": "textfield-module__em___ywiqR",
  "figcaption": "textfield-module__figcaption___Fc9-2",
  "textField": "textfield-module__textField___WzmHq",
  "textField-color-black": "textfield-module__textField-color-black___HJE5K",
  "textField-color-gray": "textfield-module__textField-color-gray___0g6Vo",
  "hasError": "textfield-module__hasError___x4ezM",
  "textField-color-white": "textfield-module__textField-color-white___5WkuT",
  "textField-size-l": "textfield-module__textField-size-l___ngvT2",
  "textField-size-m": "textfield-module__textField-size-m___F6hOI",
  "textField-size-s": "textfield-module__textField-size-s___Saibg"
};

// src/textField/TextField.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var TextField = ({
  id,
  inputType = "text",
  label,
  onChange,
  name,
  value,
  placeholder,
  disabled = false,
  readOnly = false,
  helperMessage,
  helperIcon,
  errorMessage,
  className,
  maxLength,
  minLength,
  autoComplete,
  color = "black",
  size = "m",
  ["aria-describedby"]: describedBy,
  ...HTMLAttributes
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    FormFieldWrapper_default,
    {
      color,
      size,
      label,
      helperMessage,
      helperIcon,
      errorMessage,
      className: (0, import_classnames3.default)(
        textfield_module_default.textField,
        textfield_module_default[`textField-color-${color}`],
        textfield_module_default[`textField-size-${size}`],
        className
      ),
      "aria-describedby": describedBy,
      children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
        "input",
        {
          id,
          type: inputType,
          name,
          value,
          placeholder,
          readOnly,
          disabled,
          maxLength,
          minLength,
          autoComplete,
          onChange,
          className: (0, import_classnames3.default)({
            [textfield_module_default.hasError]: errorMessage
          }),
          ...HTMLAttributes,
          "aria-disabled": disabled || HTMLAttributes["aria-disabled"]
        }
      )
    }
  );
};
var TextField_default = TextField;
//# sourceMappingURL=index.js.map